module.exports = __webpack_public_path__ + "static/media/yxzg.c6108c00.jpg";